var map = {
	"./de.ts": [
		"4qHJ",
		20
	],
	"./en.ts": [
		"L5rY",
		0
	],
	"./es.ts": [
		"Onnu",
		21
	],
	"./sq.ts": [
		"Vqk0",
		22
	],
	"./sw.ts": [
		"KR1M",
		23
	],
	"./translation-list.ts": [
		"WwKa"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "9WRL";
module.exports = webpackAsyncContext;